/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
// Event Delegation für Subscription Widgets
// ============================================
// Subscription Widget Handler (Global)
// ============================================
(function() {
  'use strict';

  // Initialize widgets
  function initSubscriptionWidget(widget) {
    if (widget.dataset.initialized === 'true') return;
    widget.dataset.initialized = 'true';

    const cards = widget.querySelectorAll('.zbv-sub-mini__card');
    const radios = widget.querySelectorAll('.zbv-sub-mini__radio');
    const planInput = widget.querySelector('.zbv-sub-mini__plan-input');
    const sellingPlanId = widget.dataset.sellingPlanId;
    const productId = widget.dataset.productId;

    if (!radios.length) return;

    // Radio Change Handler
    radios.forEach((radio) => {
      radio.addEventListener('change', function() {
        // Update active states
        cards.forEach(card => card.classList.remove('zbv-sub-mini__card--active'));
        if (this.checked) {
          this.closest('.zbv-sub-mini__card').classList.add('zbv-sub-mini__card--active');
        }

        // Update hidden input
        if (this.value === 'subscription') {
          planInput.value = sellingPlanId;
        } else {
          planInput.value = '';
        }
       // Popup unterdrücken wenn Abo gewählt
document.body.dataset.zbvPurchaseType = this.value; // 'subscription' oder 'one_time'

        // Update corresponding form if exists
        const productItem = widget.closest('product-item');
        if (productItem) {
          const form = productItem.querySelector(`form[data-product-id="${productId}"]`);
          if (form) {
            let sellingPlanField = form.querySelector('input[name="selling_plan"]');
            
            if (!sellingPlanField) {
              sellingPlanField = document.createElement('input');
              sellingPlanField.type = 'hidden';
              sellingPlanField.name = 'selling_plan';
              form.appendChild(sellingPlanField);
            }

            sellingPlanField.value = planInput.value;
          }
        }
      });
    });

    // Quick Buy Integration
    const quickBuyButtons = document.querySelectorAll(`[aria-controls*="${productId}"]`);
    quickBuyButtons.forEach(button => {
      button.addEventListener('click', function() {
        const selectedRadio = widget.querySelector('.zbv-sub-mini__radio:checked');
        if (selectedRadio) {
          sessionStorage.setItem(`zbv-sub-selection-${productId}`, selectedRadio.value);
          sessionStorage.setItem(`zbv-sub-plan-${productId}`, planInput.value);
        }
      });
    });
  }

  // Initialize all widgets on page
  function initAllWidgets() {
    document.querySelectorAll('.zbv-sub-mini').forEach(widget => {
      initSubscriptionWidget(widget);
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllWidgets);
  } else {
    initAllWidgets();
  }

  // Watch for dynamically added widgets (Product Recommendations)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if the node itself is a widget
          if (node.classList && node.classList.contains('zbv-sub-mini')) {
            initSubscriptionWidget(node);
          }
          // Check for widgets inside the added node
          const widgets = node.querySelectorAll ? node.querySelectorAll('.zbv-sub-mini') : [];
          widgets.forEach(widget => initSubscriptionWidget(widget));
        }
      });
    });
  });

  // Observe the entire document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
// ============================================
// UpPromote Widget auf Set-LPs ausblenden
// ============================================
(function hideUpWidgetOnSpecUrls() {
  const pathsStartWith = [
    '/pages/zeolite-cura-disintossicazione-set-offerta-capsule-google',
    '/pages/zeolite-cura-disintossicazione-set-offerta-google',
    '/pages/zeolith-entgiftungskur-aktions-set',
    '/pages/rabatte',
    '/pages/aktionen',
    '/pages/erfahrungen',
    '/pages/premium-paket',
    '/pages/entgiftungspakete',
    '/pages/darm-balance-paket',
    '/pages/zeolith-entgiftungskur-aktions-set-bhw',
    '/pages/zeolith-entgiftungskur-aktions-sets-print',
    '/pages/zeolith-entgiftungskur-aktions-set-google',
    '/pages/zeolith-entgiftungskur-aktions-set-zk200-google',
    '/pages/detox-ratgeber-button',
    '/pages/agb-rg',
    '/pages/zeolith-entgiftungskur-angebot-naomi'
  ];

  const needHide = pathsStartWith.some(function (path) {
    return window.location.pathname.startsWith(path);
  });

  function hideWidgetOnReady() {
    const style = document.createElement('style');
    style.id = 'uppromote-crf-customize';
    style.textContent = `div.sca_aff_customer_refer_container { display: none !important; }`;
    document.head.append(style);
  }

  if (needHide) {
    hideWidgetOnReady();
  }
})();
      
// Upsell-Popup im EU-Store automatisch schließen
if (window.location.hostname.includes('.eu')) {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // Popup-Modal gefunden
          const modal = node.classList && node.classList.contains('popup-upsell-modal')
            ? node
            : node.querySelector && node.querySelector('.popup-upsell-modal');
          
          if (modal) {
            // Sofort den "Nur Pulver"-Button klicken (= ohne Upsell in den Warenkorb)
            const closeBtn = modal.querySelector('.popup-upsell-close') 
                          || modal.querySelector('[aria-label="Close"]');
                if (closeBtn) closeBtn.click();
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Auch für bereits vorhandene Popups (falls DOM schon geladen)
  document.addEventListener('DOMContentLoaded', function() {
    const modal = document.querySelector('.popup-upsell-modal');
    if (modal) {
      const closeBtn = modal.querySelector('.popup-upsell-close') 
                    || modal.querySelector('[aria-label="Close"]');
      if (closeBtn) closeBtn.click();
    }
  });
}

  // Popup Upsell Übersetzung
(function() {
  function getLanguage() {
    var path = window.location.pathname;
    var langMatch = path.match(/^\/(en|it|es|de)\//);
    if (langMatch) return langMatch[1];

    var host = window.location.hostname;
    if (host.indexOf('.it') !== -1) return 'it';
    if (host.indexOf('.es') !== -1) return 'es';
    if (host.indexOf('.eu') !== -1) return 'en';
    return 'de';
  }

  function isCapsuleProduct() {
    var path = window.location.pathname.toLowerCase();
    return /kapseln|capsule|capsules|capsulas/.test(path);
  }

  function translatePopup() {
    var lang = getLanguage();
    var capsule = isCapsuleProduct();
    var translations = [];

    if (lang === 'it') {
      translations = [
        {
          from: 'Ideal für Ihre 12-Wochen-Darmentgiftungskur',
          to: capsule
            ? 'Ideale per la tua disintossicazione intestinale'
            : 'Ideale per la tua cura di disintossicazione intestinale di 12 settimane'
        },
        { from: 'SPAREN', to: 'RISPARMI' }
      ];
    } else if (lang === 'es') {
      translations = [
        {
          from: 'Ideal für Ihre 12-Wochen-Darmentgiftungskur',
          to: capsule
            ? 'Ideal para tu desintoxicación intestinal'
            : 'Ideal para tu cura de desintoxicación intestinal de 12 semanas'
        },
        { from: 'SPAREN', to: 'AHORRAS' }
      ];
    } else if (lang === 'en') {
      translations = [
        {
          from: 'Ideal für Ihre 12-Wochen-Darmentgiftungskur',
          to: capsule
            ? 'Ideal for your intestinal detox'
            : 'Ideal for your 12-week intestinal detox cure'
        },
        { from: 'SPAREN', to: 'SAVE' }
      ];
    } else {
      // Deutsch
      translations = [
        {
          from: 'Ideal für Ihre 12-Wochen-Darmentgiftungskur',
          to: capsule
            ? 'Ideal für deine Darmentgiftung'
            : 'Ideal für Ihre 12-Wochen-Darmentgiftungskur'
        }
        // SPAREN bleibt auf Deutsch unverändert
      ];
    }

    function replaceInPopup() {
      var elements = document.querySelectorAll(
        '.popup-upsell__product-subtitle, .popup-upsell__price-badge'
      );
      elements.forEach(function(el) {
        translations.forEach(function(t) {
          if (el.innerHTML.indexOf(t.from) !== -1) {
            el.innerHTML = el.innerHTML.replace(new RegExp(t.from, 'g'), t.to);
          }
        });
      });
    }

    replaceInPopup();

    // Beobachtet das DOM wenn das Popup dynamisch eingeblendet wird
var translateObserver = new MutationObserver(function(mutations, obs) {
  var popupExists = document.querySelector('.popup-upsell__product-subtitle, .popup-upsell__price-badge');
  if (popupExists) {
    replaceInPopup();
    obs.disconnect(); // Stopp nach einmaliger Übersetzung – verhindert Endlosschleife!
  }
});

translateObserver.observe(document.body, { childList: true, subtree: true });

  }

  document.addEventListener('DOMContentLoaded', translatePopup);
  window.addEventListener('load', translatePopup);
})();
// ============================================
// Bundler Popup bei Abo-Auswahl unterdrücken
// ============================================
(function() {

  // Schritt 1: Auf alle Abo-Radios hören (groß + mini)
  function bindRadios() {
    document.querySelectorAll('input.zbv-sub__radio, input.zbv-sub-mini__radio').forEach(function(radio) {
      if (radio.dataset.zbvBound) return;
      radio.dataset.zbvBound = 'true';
      radio.addEventListener('change', function() {
        document.body.dataset.zbvPurchaseType = this.value;
      });
    });
  }

  bindRadios();

  // Auch für dynamisch geladene Widgets
  new MutationObserver(function() {
    bindRadios();
  }).observe(document.body, { childList: true, subtree: true });

  // Schritt 2: Popup abfangen wenn is-visible gesetzt wird
  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        mutation.target.classList.contains('popup-upsell-modal') &&
        mutation.target.classList.contains('is-visible') &&
        document.body.dataset.zbvPurchaseType === 'subscription'
      ) {
        var closeBtn = mutation.target.querySelector('.popup-upsell-close');
        if (closeBtn) closeBtn.click();
      }
    });
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });

})();
// ============================================
// PageFly Sticky-Button: Erst nach Scrolltiefe zeigen
// ============================================
(function() {
  var hasScrolled = false;

  function enableStickyWhenReady() {
    var sticky = document.getElementById('sticky01');
    if (!sticky) return;

    function onScroll() {
      if (hasScrolled) return;
      if (window.scrollY > 10) {
        hasScrolled = true;
        window.removeEventListener('scroll', onScroll);
        // Kurze Verzögerung damit PageFly seine eigene Logik zuerst ausführt
        setTimeout(function() {
          sticky.classList.add('zbv-sticky-ready');
        }, 150);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableStickyWhenReady);
  } else {
    enableStickyWhenReady();
  }
})();